import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
interface BlogPost {
  title: string;
  excerpt: string;
  image: string;
  category: string;
}

interface BlogCardProps {
  post: BlogPost;
}

const BlogCard: React.FC<BlogCardProps> = ({ post }) => {
  const navigate = useNavigate();
  return (
    <article className="group relative h-[400px] rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
    onClick={() => navigate(`/blog/comment-construire-une-startup-tech-qui-dure`)}
    >
      {/* Background Image */}
      <div  className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent z-10" />
        <img
          src={post.image}
          alt={post.title}
          className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
        />
      </div>

      {/* Content */}
      <div className="relative z-20 h-full flex flex-col justify-end p-6">
        <div className="flex items-center gap-2 mb-3">
          <span className="px-3 py-1 bg-white/10 backdrop-blur-sm text-white text-sm rounded-full border border-white/20">
            {post.category}
          </span>
        </div>

        <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-orcsys-300 transition-colors duration-300 line-clamp-2">
          {post.title}
        </h3>
        
        <p className="text-white/90 line-clamp-2 text-sm">
          {post.excerpt}
        </p>
      </div>
    </article>
  );
};

export default BlogCard; 